<template>
  <article class="teacher-card card" @click="$emit('click')">
    <div class="teacher-card__top">
      <div class="teacher-card__profile">
        <div class="avatar avatar--lg" />
        <p class="teacher-card__name">
          {{ teacher.name }}
          <span v-if="teacher.verified" class="teacher-card__verified">✓</span>
        </p>
      </div>
      <p class="teacher-card__bio">{{ teacher.bio }}</p>
    </div>
    <div class="teacher-card__tags">
      <span v-for="tag in teacher.tags" :key="tag" class="tag">{{ tag }}</span>
    </div>
  </article>
</template>

<script>
export default {
  name: 'TeacherCard',
  props: {
    teacher: {
      type: Object,
      required: true,
    },
  },
  emits: ['click'],
}
</script>

<style scoped>
.teacher-card {
  padding: 16px;
  width: 300px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
}

@media (min-width: 768px) {
  .teacher-card {
    width: auto;
  }
}

.teacher-card__top {
  display: flex;
  gap: 14px;
}

.teacher-card__profile {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: 90px;
}

.teacher-card__name {
  font-size: 13px;
  font-weight: 700;
  margin-top: 8px;
  text-align: center;
  display: flex;
  align-items: center;
  gap: 4px;
}

.teacher-card__verified {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  background: #2c3e50;
  color: var(--color-white);
  border-radius: 50%;
  font-size: 9px;
}

.teacher-card__bio {
  font-size: 12px;
  color: var(--color-text-secondary);
  line-height: 1.7;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.teacher-card__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

@media (min-width: 768px) {
  .teacher-card__top {
    flex-direction: column;
    align-items: flex-start;
  }

  .teacher-card__profile {
    flex-direction: row;
    width: auto;
    gap: 14px;
    align-items: center;
  }

  .teacher-card__name {
    margin-top: 0;
    text-align: left;
    font-size: 15px;
  }

  .teacher-card__bio {
    -webkit-line-clamp: 4;
  }
}
</style>
